import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Set the Polish default before Angular bootstraps to prevent a flash of English.
function setInitialLanguage(): void {
  try {
    if (!localStorage.getItem('selectedLanguage')) {
      localStorage.setItem('selectedLanguage', 'pl');
    }
  } catch (error) {
    console.warn('Could not save the default Polish language preference', error);
  }
}

// Run before Angular bootstraps
setInitialLanguage();

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch((err) => console.error('Failed to bootstrap the Brocom storefront', err));

// Inject Vercel Speed Insights script only in production
if (environment.production) {
  const vercelScript = document.createElement('script');
  vercelScript.defer = true;
  vercelScript.src = 'https://va.vercel-scripts.com/v1/speed-insights/script.js';
  document.head.appendChild(vercelScript);
}
